import { render, staticRenderFns } from "./OfferBlacklist.vue?vue&type=template&id=78098463&"
import script from "./OfferBlacklist.vue?vue&type=script&lang=js&"
export * from "./OfferBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports